import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static values = {
        'enable': {
            default: false,
            type: Boolean,
        }
    }

    enableValueChanged() {
        document.documentElement.classList.toggle('dark', this.enableValue)
    }
}
